import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { ReportePaquetesPPForm } from "./form";

type Entity = models.ReportePaquetesPPParametros;

interface Props {
    IdClienteUsuario: number | undefined;
    permisos: models.Rol;
}

interface State {
    value: Promise<Entity> | Entity;
}

class ReportePaquetesPPNoRX extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: {
                IdCliente: this.props.permisos.Documentacion.DocumentarCualquierClienteOrigen ? undefined : this.props.IdClienteUsuario
            }
        };
    }

    puedeCambiarCliente = (props: Props) => props.permisos.Documentacion.DocumentarCualquierClienteOrigen;

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onGenerar = async () => {
        const value = await this.state.value;
        var reporte = await resources.PaquetePP.ReportePaquetesPP(value);
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte de paquetes de PP.xls");
    }

    render() {
        const puedeCambiarCliente = this.puedeCambiarCliente(this.props);
        return <ReportePaquetesPPForm
            value={this.state.value}
            onChange={this.onChange}
            onGenerar={this.onGenerar}
            puedeCambiarCliente={puedeCambiarCliente}
            permisos = { this.props.permisos }
        />;
    }
}

const ReportePaquetesPPRX = componentToRx(ReportePaquetesPPNoRX);

export class ReportePaquetesPP extends React.PureComponent {

    session = () => resources.User.SessionRx;
    idClienteUsuario = createSelectorRx(this.session, (session) => (session.IdCliente || undefined));

    render() {
        const idClienteUsuario = this.idClienteUsuario(this);
        return <ReportePaquetesPPRX
            permisos={resources.User.PermisoRx}
            IdClienteUsuario={idClienteUsuario}
        />;
    }

}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportepaquetepp/index.tsx